import ViewportActionCreator from 'action_creators/viewport';

ViewportActionCreator.watchForResize();
